module.exports = __webpack_public_path__ + "static/assets/063892ef24eec57459ee932cec7e12e5.png";